import api from '@/api';
import eventBus from '@/utils/eventBus';
import { setStore, getStore, isPartnerM, isNotNull, removeStore, isControlled, isNewProduct } from '@/utils/mUtils';

export const PackagePage = {
  data () {
    return {
      dialogFormVisible: false,
      packageform: {
        packageLine: '',
        packageCategories: '',
        packageSeries: '',
        keys: ''
      },
      allpackageLines: [],
      allpackageCategories: [],
      allpackageSeries: [],
      userCollectionPackage: 'userCollectionPackage',
      packageInitListVO: [],
      isPartner: true,
      loadflg: true
    };
  },
  methods: {
    isNotNull,
    isControlled,
    isNewProduct,
    handleClick (tab, event) {
      // tab.style. = 'red';
    },
    showRemark (scope) {
      // eslint-disable-next-line no-mixed-operators
      if ((scope.remarks !== '' && scope.remarks !== null) ||
        // eslint-disable-next-line no-mixed-operators
        ((scope.isSpdc && (this.isPartner && getStore('partnerAuth') === '1' || !this.isPartner)) ||
          // eslint-disable-next-line no-mixed-operators
          scope.isDiscount && scope.promotionPrice !== null) && !this.isPartner) {
        return true;
      } else {
        return false;
      }
    },
    showDiscount (scope) {
      return !!(scope.isDiscount && !this.isPartner);
    },

    openPackageCollection () {
      this.isPartner = isPartnerM();
      this.getPackageLineList();
      this.getPackageCategories();
      this.getPackageSeriesList();
      this.getPackageProductRelationList();
    },
    // 获取产品线下拉列表
    getPackageLineList () {
      api.getPackageLineList({ params: { userCollection: this.userCollectionPackage } }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.allpackageLines = json.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
      });
    },
    // 清空产品线同时清空产品大类，产品系列
    clearLine () {
      // 产品大类
      this.allpackageCategories = [];
      this.packageform.packageCategories = '';
      // 产品系列
      this.allpackageSeries = [];
      this.packageform.packageSeries = '';
    },
    // 选择产品线改变事件
    onPackageLineChange () {
      // 清空产品大类、系列选中值
      this.packageform.packageCategories = '';
      this.packageform.packageSeries = '';
      this.getPackageCategories();
      // 产品系列
      this.allpackageSeries = [];
      this.packageform.packageSeries = '';
      this.getPackageSeriesList();
      this.seachPackageForm();
    },
    // 获取产品大类下拉列表
    getPackageCategories () {
      let param = {
        params: {
          lineId: this.packageform.packageLine.lineId,
          userCollection: this.userCollectionPackage
        }
      };
      api.getPackageCategoriesList(param).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.allpackageCategories = json.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
      });
    },
    // 清空产品大类，同时清空产品系列
    clearPackageCategories () {
      // 重置产品系列列表数据
      this.allpackageSeries = [];
      this.packageform.packageSeries = '';
      this.onPackageLineChange();
    },
    // 选择产品大类改变事件
    onPackageCategoriesChange () {
      // 清空产品系列选中值
      this.packageform.packageSeries = '';
      this.getPackageSeriesList();
      this.seachPackageForm();
    },
    // 获取产品系列列表
    getPackageSeriesList () {
      let param = {
        params: {
          lineId: this.packageform.packageLine.lineId,
          categoryId: this.packageform.packageCategories.categoryId,
          userCollection: this.userCollectionPackage,
          keys: this.packageform.keys
        }
      };
      api.getPackageSeriesList(param).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.allpackageSeries = json.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch(() => {
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
      });
    },
    // 重置搜索框
    resetPackageForm (formName) {
      // 重置产品大类列表数据
      this.allpackageCategories = [];
      // 重置产品系列列表数据
      this.allpackageSeries = [];
      // 重置产品分类
      this.$refs[formName].resetFields();
      this.getPackageLineList();
      this.getPackageCategories();
      this.getPackageSeriesList();
      this.seachPackageForm();
    },
    // 搜索功能
    seachPackageForm () {
      let param = {
          lineId: this.packageform.packageLine !== '' ? this.packageform.packageLine.lineId : '',
          categoryId: this.packageform.packageCategories !== '' ? this.packageform.packageCategories.categoryId : '',
          seriesId: this.packageform.packageSeries !== '' ? this.packageform.packageSeries.seriesId : '',
          keys: this.packageform.keys
      };
      api.getPackageProductRelationList(param).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.packageInitListVO = json.data.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch((e) => {
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
        console.error('e', e);
      });
    },
    getPackageProductRelationList () {
      let param = {
          lineId: '',
          categoryId: '',
          seriesId: '',
          keys: ''
      };
      api.getPackageProductRelationList(param).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.packageInitListVO = json.data.data;
        } else {
          this.$notify.error(json.err);
        }
      }).catch((e) => {
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
        console.error('e', e);
      });
    },
    // 添加至配置组
    addPackageToGroupSubItem () {
      if (this.loadflg) {
        this.loadflg = false;
        let packageInitListVO = this.packageInitListVO.filter((item) => item.purchaseQuantity > 0);
        console.log(packageInitListVO);
        if (packageInitListVO != null && packageInitListVO.length > 0) {
          let body = {
            typeOptions: 2,
            groupId: this.configurationGroup.groupId,
            packageVoList: packageInitListVO
          };
          api.addPackageToGroupSubItem(body).then((res) => {
            let json = res.data;
            if (json.status === '200') {
              // 跳转到已添加产品
              // this.added();
              this.$notify.success(this.$t('addConfigModule.addGroupNameSuccess'));
            } else {
              this.$notify.error(json.err);
            }
            this.loadflg = true;
          }).catch(() => {
            this.loadflg = true;
            this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
          });
        } else {
          this.loadflg = true;
          this.$notify.error(this.$t('addConfigModule.changeNotProduct'));
        }
      }
    },
    updatePackage (item) {
      let body = {
        packageId: item.packageId,
        productId: item.productId,
        quantity: item.quantity
      };
      api.updatePackage(body).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.$notify.success(this.$t('addConfigModule.editSingleProductNumSuccessfully'));
        }
      }).catch(e => {
        this.$notify.error(this.$t('addConfigModule.editSingleProductNumFaild'));
      });
    },
    deletePackage (item) {
      this.$confirm(this.$t('addConfigModule.deleteProductsMsg'), this.$t('addConfigModule.prompt'), {
        confirmButtonText: this.$t('addConfigModule.determine'),
        cancelButtonText: this.$t('addConfigModule.cancel'),
        type: 'warning'
      }).then(() => {
        let params = {
          params: {
            packageId: item.packageId,
            productId: item.productId
          }
        };
        api.deletePackage(params).then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.$notify.success(this.$t('addConfigModule.deletedCombinedProductSuccessfully'));
            this.getPackageProductRelationList();
          }
        }).catch(e => {
          this.$notify.error(this.$t('addConfigModule.deletedCombinedProductFail'));
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('addConfigModule.hasBeenDelete')
        });
      });
    },
    updatePackageName (packageItem) {
      let body = {
        packageId: packageItem.packageId,
        packageName: packageItem.packageName
      };
      api.updatePackage(body).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.$notify.success(this.$t('addConfigModule.editCombinedProductNameSuccessfully'));
        } else {
          this.$notify.error(this.$t('addConfigModule.editCombinedProductNameFailMsg'));
        }
      }).catch(e => {
        this.$notify.error(this.$t('addConfigModule.editCombinedProductNameFail'));
      });
    },
    gobackAdded () {
      this.noticeText = '';
      this.allProductCategories = [];
      // 重置产品系列列表数据
      this.allProductSeries = [];
      // 重置产品分类
      this.allLinePropertyMap = [];
      this.$refs['form'].resetFields();
      this.dialogFormVisible = false;
      this.allpackageCategories = [];
      // 重置产品系列列表数据
      this.allpackageSeries = [];
      // 重置产品分类
      this.allpackageLines = [];
      this.$refs['packageform'].resetFields();
      this.dialogFormVisible = false;

      eventBus.$emit('loadData');
    }
  }
};
